<template>
    <div class="footer">
        <div class="content-footer">
            <h4>&copy; Aaron Gabriel Fulgar</h4>
            <h5>
                <a class="footer-link" href="https://www.facebook.com/fxz.gg" target="_blank">
                    <i class="fa-brands fa-facebook"></i>
                </a>
                <a class="footer-link" href="https://www.messenger.com/t/100006384571053" target="_blank">
                    <i class="fa-brands fa-facebook-messenger"></i>
                </a>
                <a class="footer-link" href="https://www.instagram.com/gabriel.a.gtfo/" target="_blank">
                    <i class="fa-brands fa-instagram"></i>
                </a>
                <a class="footer-link" href="https://www.linkedin.com/in/aaron-gabriel-fulgar/" target="_blank">
                    <i class="fa-brands fa-linkedin"></i>
                </a>
            </h5>
            <h5>
                <router-link :to="{name: 'home'}">Home</router-link> |
                <router-link :to="{name: 'about'}">About</router-link> |
                <router-link :to="{name: 'projects'}">Projects</router-link> |
                <router-link :to="{name: 'experiences'}">Experience</router-link> |
                <router-link :to="{name: 'contact'}">Contact</router-link>
            </h5>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>